
import GISToolComponent from './tool/GISToolComponent';
import RegeoCodeComponent from './GeoCode/RegeoCodeComponent';

// import DemoComponent from './demomodule/demo/DemoComponent';
export default {
    // 基础地图工具组件
    GISToolComponent,
    RegeoCodeComponent,
    // demo组件
    // DemoComponent
};

